import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client/react'
import { Card, CardHeader, CardBody, CardFooter, CardText, Button, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap'
import { gql } from '@apollo/client'
import useForm from '../CustomHooks/FormHook'
import { FORGOT_PASSWORD_MUTATION } from '../../graphql.js'
import MessageCard from '../MessageCard/MessageCard'
import './ForgotPassword.css'
import { enterKeyHandler } from '../../utils'

const FORGOT_PASSWORD = gql(FORGOT_PASSWORD_MUTATION)

export default function ForgotPassword() {
  console.log('ForgotPassword rendered')

  // set the cursor to the "email" input field
  const inputRef = useRef(null)
  useEffect(() => {
    inputRef.current.focus()
  }, [])

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleKeyDown } = useForm({ email: '' }, null, enterKeyHandler(submitClicked))
  const [emailState, setEmailState] = useState(null)
  const [success, setSuccess] = useState(false)
  const [forgotPassword] = useMutation(FORGOT_PASSWORD)

  function submitClicked() {
    if (!inputs.email) {
      setEmailState('has-danger')
    } else {
      forgotPassword({ variables: { email: inputs.email, host: window.location.origin } })
      setEmailState('has-success')
      setSuccess(true)
    }
  }

  document.body.classList.remove('side-bar-padding')

  if (success) {
    return (
      <MessageCard
        title="Request Submitted"
        message="If the email address provided matches an existing acount, an email containing a link to reset your password will be sent to that address."
        buttonText="Return To Login"
        clickUrl="/login"
      />
    )
  }

  return (
    <Card className="forgot-password-card" data-cy="forgot-password-card">
      <CardHeader tag="h4" data-cy="forgot-password-card-header">Forgot Password</CardHeader>
      <CardBody>
        <CardText data-cy="forgot-password-card-text">An email containing a link to reset your password will be sent to the email address provided below.</CardText>
        <Form>
          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              innerRef={inputRef}
              type="text"
              name="email"
              invalid={emailState === 'has-danger'}
              valid={emailState === 'has-success'}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              data-cy="forgot-password-email"
            />
            <FormFeedback>Email is a required field.</FormFeedback>
          </FormGroup>
        </Form>
      </CardBody>
      <CardFooter>
        <Button color="secondary" className="forgot-password-cancel-button" data-cy="forgot-password-cancel-button" onClick={() => navigate('/login')}>Cancel</Button>
        <Button color="primary" className="forgot-password-submit-button" data-cy="forgot-password-submit-button" onClick={submitClicked}>Submit Request</Button>
      </CardFooter>
    </Card>
  )
}
